import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeLargeAccountsComponent } from './modules/home-large-accounts/home-large-accounts.component';
import { HomePymesComponent } from './modules/home-pymes/home-pymes.component';
import { LanguagePickerComponent } from './modules/language-picker/language-picker.component';
import { NewContractPymesComponent } from './modules/new-contract-pymes/new-contract-pymes.component';
import { ReportsComponent } from './modules/reports/reports.component';
import { NewOfferComponent } from './modules/new-offer/new-offer.component';
import { NewContractLargeAccountsComponent } from './modules/new-contract-large-accounts/new-contract-large-accounts.component';
import { RiskWarningModalComponent } from './modules/risk-warning-modal/risk-warning-modal.component';
import { RouteRedirectGuard } from './route-redirect.guard';
import { RenovateContractPymesComponent } from './modules/renovate-contract-pymes/pages/renovate-contract-pymes.component';
import { NewContractPymesMultipointComponent } from './modules/new-contract-pymes-multipoint/new-contract-pymes-multipoint.component';

const routes: Routes = [
  { path: '', redirectTo: '/home-pymes', pathMatch: 'full' },
  {
    path: 'home-pymes',
    component: HomePymesComponent,
    data: {
      roles: ['300000003', '300000004', '300000005', '300000006', '300000007']
    },
    canActivate: [RouteRedirectGuard]
  },
  {
    path: 'home-large-accounts',
    component: HomeLargeAccountsComponent,
    data: {
      roles: ['300000001', '300000002']
    }
  },
  {
    path: 'customers',
    loadChildren: () => import('./modules/customers/customers.module').then(m => m.CustomersModule)
  },
  {
    path: 'tracing',
    loadChildren: () => import('./modules/tracing/tracing.module').then(m => m.TracingModule)
  },
  {
    path: 'campaigns',
    loadChildren: () => import('./modules/campaigns/campaigns.module').then(m => m.CampaignsModule)
  },
  {
    path: 'incidents',
    loadChildren: () => import('./modules/incidents/incidents.module').then(m => m.IncidentsModule)
  },
  {
    path: 'resources',
    loadChildren: () => import('./modules/resources/resources.module').then(m => m.ResourcesModule)
  },
  {
    path: 'sipsdata',
    loadChildren: () => import('./modules/sips-data/sips-data.module').then(m => m.SipsDataModule)
  },
  {
    path: 'reports',
    component: ReportsComponent
  },
  {
    path: 'choose-language',
    component: LanguagePickerComponent
  },
  {
    path: 'risk-warning',
    component: RiskWarningModalComponent
  },
  {
    path: 'new-contract-large-accounts',
    component: NewContractLargeAccountsComponent,
    data: {
      roles: ['300000001', '300000002']
    },
    canActivate: [RouteRedirectGuard]
  },
  {
    path: 'new-contract-pymes',
    component: NewContractPymesComponent,
    data: {
      roles: ['300000003', '300000004', '300000005', '300000006', '300000007']
    },
    canActivate: [RouteRedirectGuard]
  },
  {
    path: 'new-contract-pymes-multipoint',
    component: NewContractPymesMultipointComponent,
    data: {
      roles: ['300000003', '300000004', '300000005', '300000006', '300000007']
    },
    canActivate: [RouteRedirectGuard]
  },
  {
    path: 'draft',
    component: NewContractPymesComponent,
    data: {
      roles: ['300000003', '300000004', '300000005', '300000006', '300000007']
    },
    canActivate: [RouteRedirectGuard]
  },
  {
    path: 'new-offer',
    component: NewOfferComponent,
    data: {
      roles: ['300000001', '300000002']
    },
    canActivate: [RouteRedirectGuard]
  },
  {
    path: 'renovate-contract-pymes',
    component: RenovateContractPymesComponent,
    data: {
      roles: ['300000003', '300000004', '300000005', '300000006', '300000007']
    },
    canActivate: [RouteRedirectGuard]
  },
  {
    path: 'user-management',
    data: {
      roles: ['300000003', '300000004', '300000005', '300000006', '300000007']
    },
    loadChildren: () => import('./modules/user-management/user-management.module').then(m => m.UserManagementModule),
    canActivate: [RouteRedirectGuard]
  },
  {
    path: 'simulations',
    data: {
      roles: ['300000001', '300000002', '300000003', '300000004', '300000005', '300000006', '300000007']
    },
    canActivate: [RouteRedirectGuard],
    loadChildren: () => import('./modules/simulations/simulations.module').then(m => m.SimulationsModule)
  },
  {
    path: 'change-product',
    data: {
      roles: ['300000003', '300000004', '300000005', '300000006', '300000007']
    },
    canActivate: [RouteRedirectGuard],
    loadChildren: () => import('./modules/change-product/change-product.module').then(m => m.ChangeProductModule)
  },
  {
    path: 'change-product-multipoint',
    data: {
      roles: ['300000003', '300000004', '300000005', '300000006', '300000007']
    },
    canActivate: [RouteRedirectGuard],
    loadChildren: () => import('./modules/change-product-multipoint/change-product-multipoint.module').then(
      m => m.ChangeProductMultipointModule
    )
  },
  {
    path: 'renovate-contract-multipoint',
    data: {
      roles: ['300000003', '300000004', '300000005', '300000006', '300000007']
    },
    canActivate: [RouteRedirectGuard],
    loadChildren: () => import('./modules/renovate-contract-multipoint/renovate-contract-multipoint.module').then(
      m => m.RenovateContractMultipointModule
    )
  },
  {
    path: 'contracts',
    loadChildren: () => import('./modules/contracts/contracts.module').then(m => m.ContractsModule)
  },
  // {
  //   path: 'co2',
  //   loadChildren: () => import('./modules/co2/co2.module').then(m => m.CO2Module)
  // },
  { path: '**', redirectTo: '/home-pymes' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
